import React, { PureComponent } from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBullseye, faCheckCircle } from "@fortawesome/free-solid-svg-icons";

import { Popover, OverlayTrigger } from "react-bootstrap";

import { Button, ButtonGroup } from "aible";

import Select from "react-select";

import numeral from "numeral";
import moment from "moment";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

import SchemaMonitorContainer from "components/SchemaMonitor/SchemaMonitor";

import QualityScanPieChart from "components/Tiles/Overview/QualityScanPieChart";
import ActivityLineChart from "components/Tiles/Overview/ActivityLineChart";
import OverviewBarChart from "components/Tiles/Overview/OverviewBarChart";
import FieldTypesPieChart from "components/Tiles/Overview/FieldTypesPieChart";

import UploadBoomi from "images/boomi-two-color.svg";
import UploadCloud from "images/cloud-plus-light.svg";
import UploadCsv from "images/file-csv-light.svg";
import PartyIcon from "images/party-horn-light.svg";

import FieldTypesIcon from "images/ase-card-icons/bucket.svg";
import SizeIcon from "images/ase-card-icons/size.svg";
import StatusIcon from "images/ase-card-icons/status.svg";

import styles from "./style.module.css";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/aible/Dialog/Dialog";

export default class Overview extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      evaluateMore: undefined,
      datasetOutcomes: {},
      valueGraphType: "DATASET_COUNT",
      activityType: "MONTHLY",
      dataValueType: "BEST",
      databaseActivityType: "BEST",
      botFilter: {
        VALUABLE: true,
        USEFUL: true,
        REDUNDANT: true,
        ACTIVTY: true,
        SNOWFLAKE: true,
        ORACLE: true,
        AWS: true
      }
    };
  }

  handleOverviewSearch(overviewData) {
    const { overviewSearch } = this.props;
    overviewSearch(overviewData);
  }

  renderDataBar(overviewData, hideText = false) {
    const highSignalData = overviewData.quality_high_count;
    const mediumSignalData = overviewData.quality_medium_count;
    const lowSignalData = overviewData.quality_low_count;

    const greenWidth = (highSignalData / overviewData.dataset_count) * 100;
    const yellowWidth = (mediumSignalData / overviewData.dataset_count) * 100;
    const redWidth = (lowSignalData / overviewData.dataset_count) * 100;

    return (
      <div className={styles.dataBar}>
        {hideText === true ? <div /> : <div className={styles.dataBarText}>{overviewData.name}</div>}
        <div className={styles.dataBarOuter} style={hideText === true ? { width: "100%" } : {}}>
          <div
            className={styles.dataBarGreen}
            style={{
              width: greenWidth + "%",
              borderTopRightRadius: greenWidth === 100 ? "3px" : "none",
              borderBottomRightRadius: greenWidth === 100 ? "3px" : "none"
            }}
          />
          <div className={styles.dataBarLightGreen} style={{ width: yellowWidth + "%", left: greenWidth + "%" }} />
          <div
            className={styles.dataBarRed}
            style={{
              width: redWidth + "%",
              left: greenWidth + yellowWidth + "%"
            }}
          />
        </div>
      </div>
    );
  }

  renderOtherDataBar(overviewData, hideText = false) {
    const { dataSourceSummary } = this.props;
    const { valueGraphType } = this.state;

    const maxWidth =
      valueGraphType === "TOP_FACTORS"
        ? dataSourceSummary.reduce((a, b) => Math.max(a, b?.top_factors?.mean), 0)
        : dataSourceSummary.reduce((a, b) => Math.max(a, b?.readiness_score?.mean), 0);

    const currentWidth =
      valueGraphType === "TOP_FACTORS" ? overviewData?.top_factors?.mean : overviewData?.readiness_score?.mean;

    return (
      <div className={styles.dataBar}>
        {hideText === true ? <div /> : <div className={styles.dataBarText}>{overviewData.name}</div>}
        <div className={styles.dataBarOuter} style={hideText === true ? { width: "100%" } : {}}>
          <div
            className={styles.dataBarGreen}
            style={{
              width: (currentWidth / maxWidth) * 100 + "%"
            }}
          />
        </div>
      </div>
    );
  }

  renderDataValueBars() {
    const { dataSourceSummary } = this.props;
    const { valueGraphType } = this.state;

    return dataSourceSummary === undefined ? (
      <div />
    ) : (
      <div className={styles.dataBars}>
        {dataSourceSummary
          .sort((a, b) =>
            valueGraphType === "DATASET_COUNT"
              ? b.dataset_count - a.dataset_count
              : valueGraphType === "QUALITY_SCORE"
                ? Number(b.readiness_score?.mean) - Number(a.readiness_score?.mean)
                : valueGraphType === "TOP_FACTORS"
                  ? b.top_factors?.mean - a.top_factors?.mean
                  : b.dataset_count - a.dataset_count
          )
          .map((ds) =>
            valueGraphType === "DATASET_COUNT" ? this.renderDataBar(ds, false) : this.renderOtherDataBar(ds)
          )}
      </div>
    );
  }

  renderActivityData(isQualityScan = false) {
    const { activityData } = this.props;
    const qualityScanKeys = [
      "Active Users",
      "Database Connections",
      "Available Tables",
      "Tables Scanned",
      "Rows Scanned"
    ];
    const activityScanKeys = [
      "Datasets Fully Evaluated",
      "Projects Created",
      "Explorations Saved",
      "AI Optimizations Saved"
    ];

    return (
      <div className={styles.activityData}>
        {Object.keys(activityData)
          .filter(
            (mKey) =>
              (isQualityScan === true && qualityScanKeys.includes(mKey)) ||
              (isQualityScan === false && activityScanKeys.includes(mKey))
          )
          .map((mKey, i) => {
            return (
              <div className={styles.activityRow} key={"activity_" + i}>
                <div className={styles.activityText}>
                  <div className={styles.activityName}>{mKey}</div>
                  {activityData[mKey]?.subText !== undefined && (
                    <div className={styles.activitySubText}>{activityData[mKey]?.subText}</div>
                  )}
                </div>
                <div className={styles.activityCount}>
                  {numeral(activityData[mKey]?.count).format("0.[0]a")}
                  {activityData[mKey]?.isMoreThan ? "+" : ""}
                </div>
              </div>
            );
          })}
      </div>
    );
  }

  renderOutcomeSelection(dataset) {
    const options = dataset?.datasetOutcomeOptions;
    const oValue = this.state.datasetOutcomes?.[dataset?.id] || dataset?.outcome;

    return (
      <div className={styles.outcomeSelect}>
        <div style={{ width: "90%", marginTop: "5px" }}>
          <Select
            options={options}
            onChange={(val) => {
              let datasetOutcomes = { ...this.state.datasetOutcomes };
              datasetOutcomes[dataset?.id] = val.value;
              this.setState({ datasetOutcomes: datasetOutcomes });
            }}
            value={options.find((opt) => opt?.label === oValue)}
          />
        </div>
      </div>
    );
  }

  renderEvaluateMoreModal() {
    const { evaluateMore } = this.state;

    return (
      <div id={"evaluateMoreModal"}>
        <Dialog open={evaluateMore !== undefined} onOpenChange={() => this.setState({ evaluateMore: undefined })}>
          <DialogContent size="xl">
            <DialogHeader>
              <DialogTitle>Evaluate More Outcomes</DialogTitle>
            </DialogHeader>
            <div>
              {evaluateMore?.datasets &&
                evaluateMore.datasets
                  .filter((d) => d.dataset_status !== "ERROR")
                  .map((d, i) => (
                    <div
                      className={styles.evaluateMoreItem}
                      style={{
                        background: i % 2 !== 0 ? "#f2f3f7" : "white"
                      }}
                      key={"eval_more_" + i}
                    >
                      <div className={styles.evaluateMoreLabel}>{d.label}</div>
                      <div>{this.renderOutcomeSelection(d)}</div>
                    </div>
                  ))}
            </div>
            <DialogFooter>
              <Button onClick={() => this.setState({ evaluateMore: undefined })}>{"Cancel"}</Button>
              <Button type="primary" onClick={() => this.applyOutcomes()}>
                {"Apply"}
              </Button>
            </DialogFooter>
          </DialogContent>
        </Dialog>
      </div>
    );
  }

  applyOutcomes() {
    const { setDatasetTarget } = this.props;
    const { datasetOutcomes } = this.state;

    if (datasetOutcomes) {
      Object.keys(datasetOutcomes).forEach((dKey) => {
        setDatasetTarget(dKey, datasetOutcomes[dKey]);
      });
    }

    this.setState({ evaluateMore: undefined });
  }

  render() {
    const {
      updateIsBoomiLinkMode,
      updateIsSchemaLinkMode,
      updateIsLinkMode,
      uploadCSV,
      headerMode,
      isSchemaMonitorLoading,
      dataSourceSummary
    } = this.props;

    const { valueGraphType } = this.state;

    const bStyle = { paddingLeft: "10px", paddingRight: "10px" };
    const retItems = dataSourceSummary || [];

    return (
      <div className={styles.overviewView}>
        {this.renderEvaluateMoreModal()}
        <SchemaMonitorContainer />
        <div className={styles.overviewTop}>
          <div className={styles.overviewLeftCard}>
            <div className={styles.overviewTitle}>{"Evaluate More Data"}</div>
            {/* <div className={styles.dataImportButton}>
              <Button onClick={() => updateIsBoomiLinkMode(true)}>
                <div className={styles.uploadIcon} style={bStyle}>
                  <img src={UploadBoomi} />
                </div>
                {"Boomi Data Link"}
              </Button>
            </div> */}
            <div className={styles.dataImportButton}>
              <Button onClick={() => updateIsSchemaLinkMode(true)}>
                <div className={styles.uploadIcon} style={bStyle}>
                  <img src={UploadCloud} />
                </div>
                {"Link to Data Warehouse"}
              </Button>
            </div>
            <div className={styles.dataImportButton}>
              <Button onClick={() => updateIsLinkMode(true)}>
                <div className={styles.uploadIcon} style={bStyle}>
                  <img src={UploadCloud} />
                </div>
                {"Link to Cloud Storage"}
              </Button>
            </div>
            <div className={styles.dataImportButton}>
              <Button onClick={() => uploadCSV()}>
                <div className={styles.uploadIcon} style={bStyle}>
                  <img src={UploadCsv} />
                </div>
                {"Upload CSV"}
              </Button>
            </div>
          </div>
          <div className={styles.overviewMiddleCard}>
            <div className={styles.overviewMidSection}>
              <div className={styles.overviewTitle}>{"Data Summary"}</div>
              {this.renderActivityData(true)}
            </div>
            <div className={styles.overviewMidSection}>
              <div className={styles.overviewTitle}>{"Quality Scan Results"}</div>
              <div className={styles.midBotCenter}>
                <QualityScanPieChart data={dataSourceSummary} />
              </div>
            </div>
          </div>
          <div className={styles.overviewRightCard}>
            <div className={styles.overviewMidSection}>
              <div className={styles.overviewTitle}>{"Insight and AI Activity"}</div>
              {this.renderActivityData(false)}
            </div>
            <div className={styles.overviewMidSection}>
              <div className={styles.overviewTitle}>{"Where Your Valuable Data is Located"}</div>
              <div className={styles.valueBarActions}>
                <ButtonGroup>
                  <Button
                    onClick={() => this.setState({ valueGraphType: "DATASET_COUNT" })}
                    active={valueGraphType === "DATASET_COUNT"}
                    style={{ padding: "3px" }}
                  >
                    {"Dataset Count"}
                  </Button>
                  <Button
                    onClick={() => this.setState({ valueGraphType: "QUALITY_SCORE" })}
                    active={valueGraphType === "QUALITY_SCORE"}
                    style={{ padding: "3px" }}
                  >
                    {"Quality Score"}
                  </Button>
                  <Button
                    onClick={() => this.setState({ valueGraphType: "TOP_FACTORS" })}
                    active={valueGraphType === "TOP_FACTORS"}
                    style={{ padding: "3px" }}
                  >
                    {"Top Factors"}
                  </Button>
                </ButtonGroup>
              </div>
              <div className={styles.midBotCenter}>{this.renderDataValueBars()}</div>
            </div>
          </div>
        </div>
        <div className={styles.overviewBot}>
          {isSchemaMonitorLoading === true ? (
            this.renderLoader()
          ) : retItems.length === 0 ? (
            <div className={styles.importMessage}>{"Please import some datasets to use the Overview"}</div>
          ) : (
            <div
              className={styles.overviewBotCards}
              style={{
                borderTop: headerMode === "WORK" ? "none" : "1px solid rgba(0, 0, 0, 0.2)",
                justifyContent: retItems.length >= 3 ? "flex-start" : "center"
              }}
            >
              {retItems.map((retItem) => this.renderOverviewCard(retItem))}
            </div>
          )}
        </div>
      </div>
    );
  }

  renderLoader() {
    return (
      <div className={styles.overviewLoader}>
        <LoadingIndicator style={{ margin: "0px" }} />
      </div>
    );
  }

  renderListOverview(overviewData, i) {
    return (
      <React.Fragment key={overviewData?.type + "_" + i}>
        <tr className={styles.overviewTableRow}>
          <td>
            <input type="checkbox" />
          </td>
          <td>{overviewData?.name}</td>
          <td>{this.renderAvailableTablesBar(overviewData, true)}</td>
          <td>{this.renderQualityScannedBar(overviewData, true)}</td>
          <td>{this.renderInsightEvaluatedBar(overviewData, true)}</td>
          <td>{this.renderGraphRowsAvg(overviewData)}</td>
          <td>{this.renderGraphColumnsAvg(overviewData)}</td>
          <td>{this.renderGraphDataReadiness(overviewData)}</td>
          <td>{this.renderGraphUsefulVariables(overviewData)}</td>
          <td>{this.renderGraphInsightCount(overviewData)}</td>
          <td>{this.renderGraphUsage(overviewData)}</td>
          <td>{moment(overviewData?.updated_date).format("MMM D YYYY h:mm:ss a")}</td>
          <div className={styles.overviewTableActions}>
            <Button
              onClick={() => {
                console.log("buttons");
              }}
              style={{ padding: "9px", marginRight: "5px" }}
            >
              <div className={styles.listExpandIcon}>
                <FontAwesomeIcon icon={faBullseye} />
              </div>
              {"Scan More Tables"}
            </Button>
            <Button
              onClick={() => {
                console.log("buttons");
              }}
              style={{ padding: "9px", marginLeft: "5px" }}
            >
              <div className={styles.listExpandIcon}>
                <FontAwesomeIcon icon={faBullseye} />
              </div>
              {"Evaluated Scanned Data"}
            </Button>
          </div>
        </tr>
      </React.Fragment>
    );
  }

  renderAvailableTablesBar(overviewData, hideText = false) {
    const totalDatasets =
      overviewData?.schema_monitor?.schema?.tables !== undefined
        ? overviewData?.schema_monitor?.schema?.tables.length
        : overviewData.dataset_count;

    const pulledDatasets = Math.min(overviewData?.dataset_count, totalDatasets);

    const purpleColor = "#8556EB";
    const grayColor = "#EFECF6";

    return (
      <div className={styles.statusBar}>
        <div className={styles.statusBarText}>
          {hideText !== true && <div>{"Available Tables"}</div>}
          {numeral(totalDatasets).format("0a")}
        </div>
        <div className={styles.statusBarOuter}>
          <div
            className={styles.statusBarInner + " " + styles.roundStart}
            style={{
              background: purpleColor,
              width: "calc(" + (pulledDatasets / totalDatasets) * 100 + "% - 1px)"
            }}
          />
          <div
            className={styles.statusBarInner + " " + styles.roundEnd}
            style={{
              background: grayColor,
              width: "calc(" + (1 - pulledDatasets / totalDatasets) * 100 + "% - 1px)"
            }}
          />
        </div>
      </div>
    );
  }

  renderQualityScannedBar(overviewData, hideText = false) {
    const passedGreen = "#12BF92";
    const fixedGreen = "#8CEDB5";
    const darkRed = "rgba(203, 58, 49, 1)";

    const pulledDatasets = overviewData.dataset_count;

    const fixedDatasets = overviewData.fixed_dataset_count;
    const errorDatasets = overviewData.error_dataset_count;

    const goodDatasets = pulledDatasets - fixedDatasets - errorDatasets;

    return (
      <div className={styles.statusBar}>
        <div className={styles.statusBarText}>
          {hideText !== true && <div>{"Quality Scans"}</div>}
          {numeral(pulledDatasets).format("0a")}
        </div>
        <div className={styles.statusBarOuter}>
          <div
            className={styles.statusBarInner + " " + styles.roundStart}
            style={{
              background: passedGreen,
              width: "calc(" + (goodDatasets / pulledDatasets) * 100 + "% - 1px)"
            }}
          />
          <div
            className={styles.statusBarInner}
            style={{
              background: fixedGreen,
              width: "calc(" + (fixedDatasets / pulledDatasets) * 100 + "% - 1px)"
            }}
          />
          <div
            className={styles.statusBarInner + " " + styles.roundEnd}
            style={{
              background: darkRed,
              width: "calc(" + (errorDatasets / pulledDatasets) * 100 + "% - 1px)"
            }}
          />
        </div>
      </div>
    );
  }

  renderInsightEvaluatedBar(overviewData, hideText = false) {
    const passedGreen = "#12BF92";
    const yellowColor = "#ffcf43";
    const redColor = "#dc2626";

    const highSignalData = overviewData.quality_high_count;
    const mediumSignalData = overviewData.quality_medium_count;
    const lowSignalData = overviewData.quality_low_count;

    const evalTotal = highSignalData + mediumSignalData + lowSignalData;

    return (
      <div className={styles.statusBar}>
        <div className={styles.statusBarText}>
          {hideText !== true && <div>{"Insight Evaluations"}</div>}
          {numeral(evalTotal).format("0a")}
        </div>
        <div className={styles.statusBarOuter}>
          <div
            className={styles.statusBarInner}
            style={{
              background: passedGreen,
              width: "calc(" + (highSignalData / evalTotal) * 100 + "% - 1px)"
            }}
          />
          <div
            className={styles.statusBarInner + " " + styles.roundStart}
            style={{
              background: yellowColor,
              width: "calc(" + (mediumSignalData / evalTotal) * 100 + "% - 1px)"
            }}
          />
          <div
            className={styles.statusBarInner + " " + styles.roundEnd}
            style={{
              background: redColor,
              width: "calc(" + (lowSignalData / evalTotal) * 100 + "% - 1px)"
            }}
          />
        </div>
      </div>
    );
  }

  renderTopStatus(overviewData) {
    const purpleColor = "#8556EB";
    const fixedGreen = "#8CEDB5";

    const grayColor = "#EFECF6";
    const darkRed = "rgba(203, 58, 49, 1)";

    const passedGreen = "#12BF92";
    const yellowColor = "#ffcf43";
    const redColor = "#dc2626";

    const totalDatasets =
      overviewData?.schema_monitor?.schema?.tables !== undefined
        ? overviewData?.schema_monitor?.schema?.tables.length
        : overviewData.dataset_count;

    const pulledDatasets = Math.min(overviewData.dataset_count, totalDatasets);

    const goodDatasets =
      overviewData.dataset_count - overviewData.error_dataset_count - overviewData.fixed_dataset_count;
    const fixedDatasets = overviewData.fixed_dataset_count;
    const errorDatasets = overviewData.error_dataset_count;

    const highSignalData = overviewData.quality_high_count;
    const mediumSignalData = overviewData.quality_medium_count;
    const lowSignalData = overviewData.quality_low_count;

    const evalYellowFirst = lowSignalData;
    const evalYellowSecond = mediumSignalData;
    const evalGreen = highSignalData;

    const evalTotal = evalYellowFirst + evalGreen + evalYellowSecond;

    return (
      <div className={styles.openOverview} style={{ zIndex: 1, width: "100%" }}>
        <div className={styles.senseTitle}>
          <img src={StatusIcon} className={styles.aseIcon} />
          {"Status"}
        </div>
        <div className={styles.topStatusFlex}>
          <div className={styles.statusRight}>
            {this.renderAvailableTablesBar(overviewData)}
            {this.renderQualityScannedBar(overviewData)}
            {this.renderInsightEvaluatedBar(overviewData)}
          </div>
          <div className={styles.statusFunnel}>
            <div className={styles.funnelItem}>
              <div className={styles.funnelStatusBar}>
                <div className={styles.statusBarOuterFunnel} style={{ borderBottomRightRadius: "0px" }}>
                  <div
                    className={styles.statusBarInner}
                    style={{
                      background: purpleColor,
                      width: "calc(" + (pulledDatasets / totalDatasets) * 100 + "% - 1px)",
                      borderBottomLeftRadius: "0px"
                    }}
                  />
                  <div
                    className={styles.statusBarInner}
                    style={{
                      background: grayColor,
                      width: "calc(" + (1 - pulledDatasets / totalDatasets) * 100 + "% - 1px)"
                    }}
                  />
                </div>
              </div>
            </div>
            <div
              className={styles.triangleBar}
              style={{
                borderLeft: (1 - pulledDatasets / totalDatasets) * 110 + "px solid transparent",
                borderRight: (1 - pulledDatasets / totalDatasets) * 110 + "px dotted transparent"
              }}
            />
            <div className={styles.funnelItem}>
              <div className={styles.funnelStatusBar}>
                <div className={styles.statusBarOuterFunnel}>
                  <div
                    className={styles.statusBarInner}
                    style={{
                      background: passedGreen,
                      width: "calc(" + (goodDatasets / totalDatasets) * 100 + "% - 1px)"
                    }}
                  />
                  <div
                    className={styles.statusBarInner}
                    style={{
                      background: fixedGreen,
                      width: "calc(" + (fixedDatasets / totalDatasets) * 100 + "% - 1px)"
                    }}
                  />
                  <div
                    className={styles.statusBarInner}
                    style={{
                      background: darkRed,
                      width: "calc(" + (errorDatasets / totalDatasets) * 100 + "% - 1px)"
                    }}
                  />
                </div>
              </div>
            </div>
            <div
              className={styles.triangleBar}
              style={{
                transform: "scaleX(" + (pulledDatasets / totalDatasets) * 100 + "%)",
                borderLeft:
                  evalTotal > pulledDatasets ? 0 : (1 - evalTotal / pulledDatasets) * 110 + "px solid transparent",
                borderRight:
                  evalTotal > pulledDatasets ? 0 : (1 - evalTotal / pulledDatasets) * 110 + "px dotted transparent"
              }}
            />
            <div className={styles.funnelItem}>
              <div className={styles.funnelStatusBar}>
                <div className={styles.statusBarOuterFunnel}>
                  <div
                    className={styles.statusBarInner}
                    style={{
                      background: passedGreen,
                      width: "calc(" + (highSignalData / totalDatasets) * 100 + "% - 1px)"
                    }}
                  />
                  <div
                    className={styles.statusBarInner + " " + styles.roundStart}
                    style={{
                      background: yellowColor,
                      width: "calc(" + (mediumSignalData / totalDatasets) * 100 + "% - 1px)"
                    }}
                  />
                  <div
                    className={styles.statusBarInner + " " + styles.roundEnd}
                    style={{
                      background: redColor,
                      width: "calc(" + (lowSignalData / totalDatasets) * 100 + "% - 1px)"
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderGraphRowsAvg(overviewData) {
    return (
      <div className={styles.avgSizeGraph}>
        <OverviewBarChart
          data={
            overviewData && overviewData.datasets
              ? overviewData.datasets.map((d) => ({
                  name: d.label,
                  ["Row Count"]: d.rowCount
                }))
              : []
          }
          dataKey={"Row Count"}
        />
      </div>
    );
  }

  renderGraphColumnsAvg(overviewData) {
    return (
      <div className={styles.avgSizeGraph}>
        <OverviewBarChart
          data={
            overviewData && overviewData.datasets
              ? overviewData.datasets.map((d) => ({
                  name: d.label,
                  ["Column Count"]: d.mappings !== undefined ? d.mappings.length : 0
                }))
              : []
          }
          dataKey={"Column Count"}
        />
      </div>
    );
  }

  renderGraphDataReadiness(overviewData) {
    return (
      <div className={styles.overviewFlexSectionGraph}>
        <OverviewBarChart
          data={
            overviewData?.readiness_score?.histogram?.bins
              ? overviewData.readiness_score.histogram?.bins.map((d, i) => ({
                  name: "Readiness Score: " + d,
                  ["Dataset Count"]: overviewData?.readiness_score?.histogram?.counts[i]
                }))
              : []
          }
          dataKey={"Dataset Count"}
        />
      </div>
    );
  }

  renderGraphUsefulVariables(overviewData) {
    return (
      <div className={styles.overviewFlexSectionGraph}>
        <OverviewBarChart
          data={
            overviewData?.num_useful_variables?.histogram?.bins
              ? overviewData.num_useful_variables.histogram?.bins.map((d, i) => ({
                  name: "Useful Variables: " + d,
                  ["Dataset Count"]: overviewData?.num_useful_variables?.histogram?.counts[i]
                }))
              : []
          }
          dataKey={"Dataset Count"}
        />
      </div>
    );
  }

  renderGraphInsightCount(overviewData) {
    return (
      <div className={styles.overviewFlexSectionGraph}>
        <OverviewBarChart
          data={
            overviewData?.top_factors?.histogram?.bins
              ? overviewData.top_factors.histogram?.bins.map((d, i) => ({
                  name: "Top Factors: " + d,
                  ["Dataset Count"]: overviewData?.top_factors?.histogram?.counts[i]
                }))
              : []
          }
          dataKey={"Dataset Count"}
        />
      </div>
    );
  }

  renderDataReadiness(overviewData) {
    return (
      <div
        className={styles.openOverview}
        style={{
          width: "calc(100% - 20px)",
          marginRight: "0px"
        }}
      >
        <div className={styles.senseTitle}>
          {" "}
          <div
            className={styles.sIcon}
            style={{
              marginRight: "3px",
              fontSize: "16px"
            }}
          >
            <FontAwesomeIcon icon={faCheckCircle} />
          </div>
          {"Data Readiness and Insights"}
        </div>
        <div className={styles.overviewFlex}>
          <div className={styles.overviewFlexSection} style={{ width: "33.33%" }}>
            <div className={styles.overviewFlexSectionText}>{"DATA READINESS"}</div>
            <div className={styles.overviewFlexSectionHeroTitle}>
              {overviewData?.readiness_score?.mean !== undefined ? overviewData.readiness_score.mean.toFixed(2) : "..."}
              <div className={styles.avgText}>{"AVG"}</div>
            </div>
            {this.renderGraphDataReadiness(overviewData)}
          </div>
          <div className={styles.overviewFlexSection} style={{ width: "33.33%" }}>
            <div className={styles.overviewFlexSectionText}>{"USEFUL VARIABLES"}</div>
            <div className={styles.overviewFlexSectionHeroTitle}>
              {overviewData?.num_useful_variables?.mean !== undefined
                ? Math.round(overviewData.num_useful_variables.mean)
                : "..."}
              <div className={styles.avgText}>{"AVG"}</div>
            </div>
            {this.renderGraphUsefulVariables(overviewData)}
          </div>
          <div className={styles.overviewFlexSection} style={{ width: "33.33%" }}>
            <div className={styles.overviewFlexSectionText}>{"TOP FACTORS"}</div>
            <div className={styles.overviewFlexSectionHeroTitle}>
              {Math.round(overviewData?.top_factors?.mean)}
              <div className={styles.avgText}>{"AVG"}</div>
            </div>
            {this.renderGraphInsightCount(overviewData)}
          </div>
        </div>
      </div>
    );
  }

  renderUseCaseCallout(overviewData) {
    const { blueprints } = this.props;

    const isMatchingBlueprint = (blueprint) => {
      const outcome = blueprint?.dataset?.outcome;

      return overviewData?.datasets === undefined
        ? false
        : overviewData.datasets.reduce((a, b) => a || b.outcome === outcome, false);
    };

    const matchingBlueprints = blueprints.filter((b) => isMatchingBlueprint(b));

    return matchingBlueprints === undefined || matchingBlueprints.length === 0 ? (
      <div />
    ) : (
      <div className={styles.useCase}>
        <div className={styles.useCaseTitle}>
          <div className={styles.partyIcon}>
            <img src={PartyIcon} />
          </div>
          {matchingBlueprints.length + " Use Cases Found"}
        </div>
        <div className={styles.useCaseDesc}>
          {"Aible found data ready for "}
          {matchingBlueprints.map((b, i) => (
            <span>
              <span style={{ fontWeight: "bold" }}>{b?.wizard?.dataset?.outcome}</span>
              {i + 1 < matchingBlueprints.length && <span>{", "}</span>}
            </span>
          ))}
        </div>
      </div>
    );
  }

  renderQualityScanResults(overviewData) {
    const missingFixedCount = overviewData.missing_fixed_count;
    const uniqueValuesCount = overviewData.unique_values_count;
    const tooManyValuesCount = overviewData.too_many_values_count;
    const duplicateHeaderCount = overviewData.duplicate_header_count;
    const emptyRowsCount = overviewData.empty_rows_count;
    const headerMissingCount = overviewData.missing_header_count;
    const totalDatasets = overviewData.dataset_count;
    const outlierCount = overviewData.outlier_count;
    const errorDatasetsCount = overviewData.error_dataset_count;

    const qRows = [
      {
        text: "Outlier Detection",
        errorCount: 0,
        fixedCount: outlierCount,
        notRanCount: errorDatasetsCount
      },
      {
        text: "Missing Values",
        errorCount: 0,
        fixedCount: missingFixedCount,
        notRanCount: errorDatasetsCount
      },
      {
        text: "Too Many Values",
        errorCount: 0,
        fixedCount: tooManyValuesCount,
        notRanCount: errorDatasetsCount
      },
      {
        text: "Unique Values",
        errorCount: 0,
        fixedCount: uniqueValuesCount,
        notRanCount: errorDatasetsCount
      },
      {
        text: "Missing Headers",
        errorCount: headerMissingCount,
        fixedCount: 0
      },
      {
        text: "Duplicate Headers",
        errorCount: duplicateHeaderCount,
        fixedCount: 0
      },
      {
        text: "Empty Rows",
        errorCount: emptyRowsCount,
        fixedCount: 0
      }
    ];

    return (
      <div
        className={styles.openOverview}
        style={{
          width: "calc(50% - 10px)",
          marginRight: "0px"
        }}
      >
        <div className={styles.senseTitle}>
          <img src={SizeIcon} className={styles.aseIcon} />
          {"Quality Scan Results"}
        </div>
        <div className={styles.qualityScan}>
          {qRows.map((item, i) => (
            <OverlayTrigger
              key={"qs_" + i}
              placement="top"
              trigger={["hover"]}
              rootClose
              overlay={
                <Popover id="popover-positioned-top">
                  <div className={styles.qualityPopover}>
                    <div className={styles.qualityTitle}>{item.text + " Results"}</div>
                    <div className={styles.qualityItemPopover}>
                      <div className={styles.qualFlex}>
                        <div className={styles.qualityGoodBadge} />
                        <div className={styles.qualityType}>{"Passed"}</div>
                      </div>
                      <div className={styles.qualityCount}>
                        {Math.max(0, totalDatasets - (item.fixedCount + item.errorCount + (item.notRanCount || 0)))}
                      </div>
                    </div>
                    <div className={styles.qualityItemPopover}>
                      <div className={styles.qualFlex}>
                        <div className={styles.qualityFixedBadge} />
                        <div className={styles.qualityType}>{"Automatically Updated"}</div>
                      </div>
                      <div className={styles.qualityCount}>{item.fixedCount}</div>
                    </div>
                    <div className={styles.qualityItemPopover}>
                      <div className={styles.qualFlex}>
                        <div className={styles.qualityErrorBadge} />
                        <div className={styles.qualityType}>{"Failed"}</div>
                      </div>
                      <div className={styles.qualityCount}>{item.errorCount}</div>
                    </div>
                    <div className={styles.qualityItemPopover}>
                      <div className={styles.qualFlex}>
                        <div className={styles.qualityNotRanBadge} />
                        <div className={styles.qualityType}>{"Not Run"}</div>
                      </div>
                      <div className={styles.qualityCount}>{item.notRanCount || 0}</div>
                    </div>
                  </div>
                </Popover>
              }
            >
              <div className={styles.qualityItem}>
                <div className={styles.qualityText}>{item.text}</div>
                <div className={styles.qualityBarOuter}>
                  <div
                    className={styles.qualityBarInnerGood}
                    style={{
                      width:
                        Math.max(
                          0,
                          1 -
                            (item.fixedCount +
                              item.errorCount +
                              (item.notRanCount !== undefined ? item.notRanCount : 0)) /
                              totalDatasets
                        ) *
                          100 +
                        "%"
                    }}
                  />
                  <div
                    className={styles.qualityBarInnerFixed}
                    style={{
                      width: (item.fixedCount / totalDatasets) * 100 + "%"
                    }}
                  />
                  <div
                    className={styles.qualityBarInnerError}
                    style={{
                      width: (item.errorCount / totalDatasets) * 100 + "%"
                    }}
                  />
                  <div
                    className={styles.qualityBarInnerNotRan}
                    style={{
                      width: (item.notRanCount / totalDatasets) * 100 + "%"
                    }}
                  />
                </div>
              </div>
            </OverlayTrigger>
          ))}
        </div>
      </div>
    );
  }

  renderFieldTypes(overviewData) {
    return (
      <div
        className={styles.openOverview}
        style={{
          width: "calc(50% - 20px)",
          marginRight: "0px"
        }}
      >
        <div className={styles.senseTitle}>
          <img src={FieldTypesIcon} className={styles.aseIcon} />
          {"Field Types"}
        </div>
        <div className={styles.fieldTypes}>
          <FieldTypesPieChart data={overviewData} />
        </div>
      </div>
    );
  }

  renderEvaluateMore(overviewData) {
    const { openAndSelectSchema, uploadCSV, updateIsLinkMode } = this.props;

    return (
      <div
        className={styles.openOverview}
        style={{
          width: "calc(100% - 20px)",
          marginRight: "0px"
        }}
      >
        <div className={styles.evaluateMore}>
          <div className={styles.evaluateMoreText}>{"What would you like to do next?"}</div>
          <div className={styles.evalMoreButtons}>
            <Button
              style={{ marginRight: "5px" }}
              onClick={() => {
                if (overviewData?.name === "CSV Upload" && overviewData?.source_type === "RAW_DATA") {
                  uploadCSV();
                } else if (
                  overviewData?.source_type === "CONNECTION_METADATA" &&
                  overviewData?.name === "Cloud Storage Link"
                ) {
                  updateIsLinkMode(true);
                } else {
                  openAndSelectSchema(overviewData?.id);
                }
              }}
            >
              {"Scan More Tables"}
            </Button>
            <Button style={{ marginLeft: "5px" }} onClick={() => this.handleOverviewSearch(overviewData)}>
              {"View Scanned Data"}
            </Button>
          </div>
        </div>
      </div>
    );
  }

  renderGraphUsage() {
    return (
      <div className={styles.usageGraph}>
        <ActivityLineChart />
      </div>
    );
  }

  renderOverviewCard(overviewData) {
    const { openAndSelectSchema } = this.props;

    return (
      <div>
        <div className={styles.senseTile} id={"testCard"}>
          <div
            className={styles.tileHeader}
            style={{ background: "#34d399", color: "#4B495B" }}
            onClick={() => openAndSelectSchema(overviewData?.id)}
          >
            <div className={styles.tFlex}>
              {overviewData?.icon !== undefined ? (
                <img
                  src={overviewData.icon}
                  style={{
                    height: "30px",
                    width: "30px",
                    marginRight: "5px",
                    background: "transparent"
                  }}
                />
              ) : (
                <div />
              )}
              <div style={{ width: "100%" }}>
                <div className={styles.tileHeaderLarge}>{overviewData.name}</div>
              </div>
            </div>
          </div>
          <div className={styles.tileBody}>
            <div className={styles.senseAll}>
              {this.renderTopStatus(overviewData)}
              {this.renderQualityScanResults(overviewData)}
              {this.renderFieldTypes(overviewData)}
              {overviewData?.total_datasets_evaluated > 0 ? this.renderDataReadiness(overviewData) : <div />}
              {this.renderEvaluateMore(overviewData)}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
